<template>
  <div :class="{ 'form-control': true, 'is-select': true, 'w-100': true }">
    <v-select
      :options="itemsToDisplay"
      v-model="item"
      :placeholder="placeholder"
      @search="debouncedFetch">
      <template slot="no-options">
        <template v-if="emptyResults">No items matching phrase&hellip;</template>
      </template>
    </v-select>
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'predictable-input',
  props: [
    'endpoint',
    'labelField',
    'placeholder'
  ],
  data () {
    return {
      item: '',
      loadedItems: false,
      items: [],
      itemsToDisplay: [],
      loadError: false,
      emptyResults: false
    }
  },
  methods: {
    fetchItems (searchPhrase, loadingCallback) {
      this.emptyResults = false;

      if (!searchPhrase || searchPhrase.length === 0) {
        return;
      }

      loadingCallback(true);

      FormUtils.loadAdditionalData(this, {
        endpoint: this.endpoint,
        outputKey: 'items',
        errorKey: 'loadError',
        params: {
          pagination: 1,
          where: {
            search: searchPhrase
          }
        },
        successAction: (response) => {
          if (!response || !response.length) {
            this.emptyResults = true;
            return;
          }

          this.itemsToDisplay = this.items.filter(item => !!item[this.labelField]).map(item => ({
            id: item.id,
            label: item[this.labelField],
            value: item[this.labelField]
          }));

          loadingCallback(false);
        }
      });
    },
    // eslint-disable-next-line
    debouncedFetch: debounce(function (searchPhrase, loadingCallback) {
      this.fetchItems(searchPhrase, loadingCallback);
    }, 200)
  }
}
</script>
